<p i18n="@@components.url_integration.introduction">Embedded Parashift allows to upload and validate (separation, classification, extraction) in an iframe in your own HTML-enabled application, secured with a shared secret you should keep on a server and never expose publicly.</p>

<div class="d-flex align-items-center flex-wrap gap-3 mb-3">
  <div class="form-check form-switch mb-0">
    <input class="form-check-input" type="checkbox" role="switch" id="url-integration-switch" [checked]="embedded_login_enabled" (change)="toggleUrlIntegration($event)">
    <label class="form-check-label" for="url-integration-switch" i18n="@@components.url_integration.toggle_label">Enabled</label>
  </div>
  <a href="/integration/assets/test.html" target="_blank" rel="noopener" i18n="@@components.url_integration.test_page">Open test page</a>
</div>

@if (embedded_url_secret) {
  <p><strong i18n="@@components.url_integration.retrieved_secret_hint">Please copy the returned secret and store it in a safe place! It will only be shown once!</strong></p>
  <div class="bg-light p-2 my-3">
    <fa-icon [icon]="['fas', 'copy']"
      transform="shrink-1"
      ngxClipboard
      [cbContent]="embedded_url_secret"
      class="pointer"
      [fixedWidth]="true"
      i18n-tooltip="@@components.url_integration.secret.copy_to_clipboard" tooltip="Copy to Clipboard">
    </fa-icon>
    <span class="pointer ms-1" ngxClipboard [cbContent]="embedded_url_secret">Secret: {{ embedded_url_secret }}</span>
  </div>
}
